import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminDadosEmpresa: Routes = [
  {
    path: 'dados-empresa',
    canActivate: [RenderInterfaceGuard],
    data: {
      module: 'EMPRESA_DADOS',
      subMenuKey: 'EMPRESA',
      menuKey: 'CONFIGURACOES'
    },
    loadChildren: () =>
      import('@app/modules/dados-empresa/dados-empresa.module').then(
        m => m.DadosEmpresaModule
      )
  }
];
